import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { fbq, constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import DialogModal from 'components/modal/DialogModal/DialogModal'

import messages from './messages'
import s from './ResubscribeSuccessModal.scss'


export default class ResubscribeSuccessModal extends Component {

  static propTypes = {
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.resubscribe.ResubscribeSuccess,
  }

  componentDidMount() {
    const { data: { monthlyPrice } } = this.props

    fbq.track('Resubscribe', {
      value: monthlyPrice || 14.95,
      currency: 'USD',
    })
  }

  render() {
    const { name, data } = this.props

    return (
      <DialogModal
        name={name}
        title={messages.title}
        data={data}
      >
        <FormattedHTMLMessage className={s.text} tag="div" {...messages.text} />
      </DialogModal>
    )
  }
}
